import React, { useState, useEffect, useContext } from 'react';
import FeatherIcon from 'feather-icons-react';
import { useHistory } from 'react-router-dom';
import { upperCase, upperFirst, lowerCase } from 'lodash';

import algoliasearch from 'algoliasearch';
import { InstantSearch, connectMenu } from 'react-instantsearch-dom';

import './Widget.css';

const searchClient = algoliasearch(process.env.REACT_APP_ALGOLIAAPPID, process.env.REACT_APP_ALGOLIAPUBKEY);
const PRODUCTINDEX = process.env.REACT_APP_PRODUCTINDEX

const Products = () => {
  const history = useHistory();


  const MapIcon = (placeholder) => {
    switch (placeholder) {
      case "success":
        return "check-square";
      case "warning":
        return "edit";
      case "danger":
        return "alert-triangle";
      default:
        return "alert-triangle";
    }
  };

  const MapBadge = (placeholder) => {
    return `badge badge-pill badge-${placeholder} pill-widget`
  };


  const RefinementList = ({
    items,
    defaultRefinement,
    placeholder
  }) => (
    items.map(item =>
    (
      <div>
        {
          item.label == defaultRefinement ?
            <div className="row widget-link" onClick={event => goTo(item.label)}>
              <div className="col-9 border-bottom p-2"><FeatherIcon icon={MapIcon(placeholder)} /> {upperFirst(lowerCase(item.label))}</div>
              <div className="col-3 border-bottom p-2 text-right pr-3"><span className={MapBadge(placeholder)}>{item.count}</span></div>
            </div> : ""
        }
      </div>
    )

    ));


  const CustomMenu = connectMenu(RefinementList);

  const goTo = async (status = '') => {
    history.push(`/admin/products/status/${status}`)
  }

  return (
    <React.Fragment>
      <div className="row mt-3 border-top-widget-red border-left border-right no-gutters">
        <div className="col pl-3 pt-2">
          <h5>Products</h5>
        </div>
      </div>
      <div className="row border no-gutters p-4">

        <div className="col">
          <InstantSearch
            indexName={PRODUCTINDEX}
            searchClient={searchClient}>
            {
              <React.Fragment>
                <CustomMenu attribute="status" defaultRefinement='PENDING APPROVAL' placeholder='danger' />
                <CustomMenu attribute="status" defaultRefinement='PENDING UPDATE' placeholder='warning' />
                <CustomMenu attribute="status" defaultRefinement='ACTIVE' placeholder='success' />
              </React.Fragment>
            }
          </InstantSearch>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Products;